(() => {
  'use strict';

  if (customElements.get('salabom-quiz')) return;

  const agreementAnswers = (profile) => [
    { label: 'Súhlasím', scores: { [profile]: 1 }, tag: 'agree' },
    { label: 'Neutrálne / neviem posúdiť', scores: {}, tag: 'neutral' },
    { label: 'Nesúhlasím', scores: {}, tag: 'disagree' }
  ];

  const QUESTIONS = [
    {
      id: 'mood-sensitivity',
      text: 'V dňoch pred menštruáciou bývam podráždenejšia než počas zvyšku cyklu.',
      answers: agreementAnswers('sensitive')
    },
    {
      id: 'mood-changes',
      text: 'Pred menštruáciou u mňa častejšie dochádza k náhlym zmenám nálady alebo plačlivosti.',
      answers: agreementAnswers('sensitive')
    },
    {
      id: 'emotional-tension',
      text: 'Pred menštruáciou pociťujem zvýšené vnútorné napätie alebo úzkosť.',
      answers: agreementAnswers('sensitive')
    },
    {
      id: 'energy-drop',
      text: 'Pred menštruáciou pociťujem výrazný pokles energie aj pri bežných denných činnostiach.',
      answers: agreementAnswers('tired')
    },
    {
      id: 'rest-need',
      text: 'V tomto období potrebujem viac spánku alebo oddychu než zvyčajne.',
      answers: agreementAnswers('tired')
    },
    {
      id: 'daily-effort',
      text: 'Pred menštruáciou mi začatie bežných denných činností pripadá náročnejšie.',
      answers: agreementAnswers('tired')
    },
    {
      id: 'bloating',
      text: 'Pred menštruáciou mávam nafukovanie alebo pocit zadržiavania vody.',
      answers: agreementAnswers('body')
    },
    {
      id: 'breast-tenderness',
      text: 'Pred menštruáciou pociťujem citlivosť alebo napätie v prsníkoch.',
      answers: agreementAnswers('body')
    },
    {
      id: 'pelvic-pain',
      text: 'Pred menštruáciou pociťujem bolesť alebo tlak v podbrušku.',
      answers: agreementAnswers('body')
    },
    {
      id: 'food-cravings',
      text: 'Pred menštruáciou mávam výraznejšiu chuť na konkrétne jedlá, najmä sladké alebo slané.',
      answers: agreementAnswers('cravings')
    },
    {
      id: 'increased-appetite',
      text: 'Pred menštruáciou mám väčšiu chuť do jedla než zvyčajne.',
      answers: agreementAnswers('cravings')
    },
    {
      id: 'eating-without-hunger',
      text: 'V tomto období mávam nutkanie jesť aj vtedy, keď nepociťujem fyzický hlad.',
      answers: agreementAnswers('cravings')
    },
    {
      id: 'concentration',
      text: 'Pred menštruáciou sa mi horšie sústredí na jednu úlohu.',
      answers: agreementAnswers('overload')
    },
    {
      id: 'forgetfulness',
      text: 'Pred menštruáciou častejšie zabúdam na bežné veci alebo povinnosti.',
      answers: agreementAnswers('overload')
    },
    {
      id: 'mental-overload',
      text: 'V tomto období ma rozhodovanie alebo viac úloh naraz zahltí ľahšie než zvyčajne.',
      answers: agreementAnswers('overload')
    },
    {
      id: 'age-range',
      text: 'Do ktorej vekovej skupiny patríš?',
      hint: 'Táto odpoveď neovplyvňuje výsledný PMS typ.',
      answers: [
        { label: 'Menej ako 18 rokov', scores: {}, tag: 'under-18' },
        { label: '18 – 24 rokov', scores: {}, tag: '18-24' },
        { label: '25 – 34 rokov', scores: {}, tag: '25-34' },
        { label: '35 – 44 rokov', scores: {}, tag: '35-44' },
        { label: '45 – 54 rokov', scores: {}, tag: '45-54' },
        { label: '55 rokov a viac', scores: {}, tag: '55-plus' }
      ]
    }
  ];

  const RESULTS = {
    sensitive: {
      tag: 'quiz-pms-profile-sensitive',
      title: 'Citlivý PMS typ',
      summary: 'Tvoje odpovede naznačujú, že pred menzesom sa u teba najviac ukazuje citlivosť, podráždenosť alebo potreba jemnejšieho zaobchádzania. Neznamená to, že si „príliš citlivá“. Skôr potrebuješ menej tlaku, viac priestoru a mäkší tón od seba aj od ostatných.',
      advice: {
        food: [
          'Jedz pravidelne a ku komplexným sacharidom, ako sú ovsené vločky, celozrnné pečivo či strukoviny, pridaj zdroj bielkovín. Stabilnejší rytmus jedla môže pomôcť predísť prudkému hladu a podráždenosti.',
          'Zaraď bežné zdroje vápnika, napríklad biely jogurt, kefír, tofu obohatené vápnikom alebo listovú zeleninu.',
          'Dva cykly si zapisuj, či sa citlivosť zhoršuje po väčšom množstve kofeínu alebo alkoholu. Namiesto plošného zákazu hľadaj vlastnú súvislosť.'
        ],
        movement: [
          'Pravidelný aeróbny pohyb počas celého mesiaca býva užitočnejší než jednorazový intenzívny tréning až pri symptómoch. Začať môžeš svižnou chôdzou.',
          'V citlivejší deň vyskúšaj 10 minút chôdze alebo ľahkého bicykla bez cieľa podať výkon. Aj krátky pohyb sa počíta.',
          'Pri vnútornom napätí skús jemnú jogu alebo päť pomalých výdychov, ktoré sú o niečo dlhšie než nádychy.'
        ],
        relationships: [
          'Dohodni si s blízkym človekom jednoduchý signál, ktorým oznámiš, že potrebuješ pokojnejší tón alebo krátku pauzu.',
          'Namiesto očakávania, že druhí uhádnu tvoju potrebu, použi konkrétnu vetu: „Teraz potrebujem 20 minút sama a potom sa k tomu vrátim.“',
          'Ak rozhovor eskaluje, dohodni prestávku aj presný čas návratu. Pauza bez návratu môže pôsobiť ako odmietnutie; pauza s dohodou vytvára bezpečie.'
        ]
      }
    },
    tired: {
      tag: 'quiz-pms-profile-tired',
      title: 'Únavový PMS typ',
      summary: 'U teba PMS často prichádza ako pokles energie. Veci, ktoré inokedy zvládaš normálne, zrazu potrebujú viac úsilia. Najväčší dar pre tvoje telo v týchto dňoch nemusí byť výkon, ale múdre zjednodušenie.',
      advice: {
        food: [
          'Každé hlavné jedlo poskladaj z komplexného sacharidu a bielkoviny, napríklad zemiaky s vajíčkom, ryžu s tofu alebo ovsené vločky s jogurtom.',
          'Ak ťa veľké porcie uspávajú, vyskúšaj menšie jedlá a plánovaný snack. Cieľom nie je jesť menej, ale rozložiť energiu rovnomernejšie.',
          'Maj vodu na viditeľnom mieste a nečakaj iba na kávu. Ak kofeín narúša spánok, skús poslednú kávu posunúť na skoršiu časť dňa.'
        ],
        movement: [
          'Pravidelná svižná chôdza, bicykel alebo plávanie môžu pri PMS pomáhať aj s únavou. Dôležitejšia je pravidelnosť než vysoká intenzita.',
          'Použi pravidlo desiatich minút: začni veľmi ľahko a po desiatich minútach sa rozhodni, či pokračovať. Ak nie, aj to je platný tréning.',
          'V deň s nízkou energiou vymeň náročný tréning za mobilitu, krátku prechádzku alebo jemné natiahnutie namiesto úplného režimu „všetko alebo nič“.'
        ],
        relationships: [
          'Povedz blízkym, že máš menej energie, a pridaj konkrétnu prosbu: nákup, večeru alebo presunutie jednej povinnosti.',
          'Namiesto rušenia kontaktu navrhni menej náročnú verziu, napríklad krátku prechádzku namiesto dlhého večera.',
          'Rozlišuj medzi tým, čo musí byť hotové dnes, a tým, čo môže prevziať niekto iný. Žiadosť o pomoc nie je zlyhanie ani ospravedlnenie.'
        ]
      }
    },
    body: {
      tag: 'quiz-pms-profile-body',
      title: 'Telesný PMS typ',
      summary: 'Tvoj PMS typ sa najviac ozýva cez telo. Môžeš vnímať nafúknutie, ťažobu, napätie alebo jednoducho pocit, že potrebuješ viac pohodlia. V týchto dňoch ti môže pomôcť voľnejší režim a menej boja s vlastným telom.',
      advice: {
        food: [
          'Ak ťa trápi zadržiavanie vody, sleduj najmä veľmi slané priemyselne spracované jedlá. Tekutiny však zámerne neobmedzuj.',
          'Zaraď potraviny prirodzene bohaté na vápnik, napríklad jogurt, kefír, sardinky, tofu obohatené vápnikom alebo listovú zeleninu.',
          'Namiesto vyradenia celých skupín potravín si dva cykly zapisuj jedlo aj symptómy. Hľadaj opakujúci sa vzorec, nie vinníka po jednom náročnom dni.'
        ],
        movement: [
          'Pravidelný aeróbny pohyb počas mesiaca môže pomôcť celkovým PMS symptómom. V náročnejší deň zvoľ chôdzu, bicykel alebo plávanie v ľahkom tempe.',
          'Pri tlaku v podbrušku vyskúšaj jemnú mobilitu bedier a pokojné dýchanie; pohyb nemá zvyšovať bolesť.',
          'Intenzitu prispôsob symptómom bez výčitiek. Skrátený tréning alebo regenerácia sú vedomá úprava plánu, nie vynechanie starostlivosti o seba.'
        ],
        relationships: [
          'Pomenuj telesný problém konkrétne: „Som nafúknutá a bolí ma podbruško, dnes potrebujem pomalšie tempo.“',
          'Požiadaj blízkych, aby v týchto dňoch nekomentovali tvoje telo, oblečenie ani množstvo jedla.',
          'Pri dotyku alebo intimite povedz, čo je príjemné a čo nie. Citlivosť prsníkov či bolesť sú dostatočný dôvod upraviť hranice.'
        ]
      }
    },
    cravings: {
      tag: 'quiz-pms-profile-cravings',
      title: 'Chuťový PMS typ',
      summary: 'U teba sa PMS často hlási cez chute, apetít alebo potrebu malých odmien. Nie je to dôvod na výčitky. Skôr signál, že tvoje telo ocení stabilnejší rytmus, viac plánovania a rituály, ktoré nie sú len o zákaze.',
      advice: {
        food: [
          'Naplánuj si jedlo skôr, než príde silný hlad. Praktický snack spája sacharid a bielkovinu, napríklad ovocie s jogurtom, pečivo s hummusom alebo vločky s orechmi.',
          'Skús menšie pravidelné jedlá namiesto dlhých prestávok. Komplexné sacharidy, ako strukoviny, celozrnné obilniny či zemiaky, zasýtia dlhšie.',
          'Nezakazuj si úplne sladké ani slané. Daj si zvolenú porciu vedome a bez kompenzácie hladovaním; prísny zákaz často zvyšuje mentálny tlak okolo jedla.'
        ],
        movement: [
          'Pohyb nepoužívaj ako trest za jedlo. Krátka prechádzka môže vytvoriť pauzu a zmeniť prostredie, nemusí však „odpracovať“ snack.',
          'Pravidelný aeróbny pohyb počas mesiaca môže podporiť náladu a energiu, ktoré často ovplyvňujú aj rozhodovanie o jedle.',
          'Vyber si pohyb, ktorý je príjemný aj v PMS dňoch, napríklad chôdzu s hudbou, tanec doma alebo ľahký bicykel.'
        ],
        relationships: [
          'Požiadaj okolie, aby jedlo neoznačovalo ako „dobré“, „zlé“ alebo „prehrešok“. Neutralita znižuje zbytočné výčitky.',
          'Ak zdieľaš domácnosť, povedz dopredu, ktoré sýte snacky chceš mať poruke, a pridaj ich na spoločný nákupný zoznam.',
          'Keď potrebuješ podporu, povedz, či chceš spoločnosť, pomoc s jedlom alebo iba priestor. Nevyžiadaná kontrola jedla zvyčajne nie je podpora.'
        ]
      }
    },
    overload: {
      tag: 'quiz-pms-profile-overload',
      title: 'Zahltená hlava',
      summary: 'Tvoj PMS typ sa najviac prejavuje v hlave. Viac premýšľania, menej jasnosti, ťažšie rozhodovanie alebo pocit, že aj jednoduchý deň má priveľa vrstiev. V týchto dňoch ti môže pomôcť menej rozhodnutí a viac jednoduchých opôr.',
      advice: {
        food: [
          'Pred náročnejšími dňami si priprav dve jednoduché jedlá, ktoré nevyžadujú veľa rozhodovania, napríklad polievku, ryžu so strukovinou alebo jogurt s vločkami a ovocím.',
          'Nastav si približný čas jedla alebo viditeľný snack. Pri zahltení sa signál hladu ľahko odsunie, čo môže neskôr zhoršiť sústredenie.',
          'Ak si nervózna alebo horšie spíš, sleduj množstvo kofeínu. Skús najprv menšiu dávku alebo skorší čas, nie automaticky ďalšiu kávu.'
        ],
        movement: [
          'Krátka prechádzka bez telefónu môže poslúžiť ako prechod medzi dvoma blokmi dňa a znížiť množstvo podnetov.',
          'Vyber si opakovateľný pohyb s minimom rozhodovania: rovnaká trasa, krátka zostava alebo pevný čas.',
          'Po dlhom sústredení si daj päť minút mobility alebo chôdze. Cieľom je zmeniť stav tela, nie pridať ďalšiu úlohu na výkon.'
        ],
        relationships: [
          'Požiadaj druhých, aby ti dávali jednu požiadavku naraz a dôležité veci poslali aj písomne.',
          'Použi tri zoznamy: dnes, neskôr a nie je moje. Posledný zoznam pomáha odhaliť úlohy, ktoré môže prevziať niekto iný.',
          'Veľké alebo neurgentné rozhodnutie môžeš odložiť konkrétnou vetou: „Vrátim sa k tomu zajtra doobeda.“ Druhá strana tak vie, že ju neignoruješ.'
        ]
      }
    },
    combined: {
      tag: 'quiz-pms-profile-combined',
      title: 'Kombinovaný PMS typ',
      summary: 'Tvoje odpovede nevytvorili jeden jednoznačne dominantný vzorec. Môže sa u teba miešať citlivosť, únava, telesné nepohodlie, zmeny chuti do jedla aj mentálne zahltenie, prípadne si označila len málo výrazných symptómov. Najlepšie ti môže sadnúť postupný prístup zameraný na ťažkosti, ktoré aktuálne cítiš najsilnejšie.',
      advice: {
        food: [
          'Začni pravidelným rytmom jedla a ku komplexnému sacharidu pridaj bielkovinu. Je to praktickejší prvý krok než naraz meniť celý jedálniček.',
          'Dva až tri cykly si zapisuj symptómy, jedlo, kofeín a spánok. Hodnoť opakujúce sa súvislosti, nie jednotlivé dni.',
          'Uprednostni zdroje živín v bežnom jedle. Pred pravidelným užívaním doplnkov sa poraď s lekárom alebo lekárnikom, najmä ak užívaš lieky.'
        ],
        movement: [
          'Vyber si aeróbny pohyb, ktorý dokážeš robiť pravidelne počas mesiaca, napríklad svižnú chôdzu, bicykel alebo plávanie.',
          'V symptomatický deň zníž intenzitu alebo dĺžku, ale ponechaj malý pohybový rituál, ak sa pri ňom cítiš dobre.',
          'Ak pohyb zhoršuje bolesť, závrat alebo nevoľnosť, zastav a zvoľ oddych; výrazné či nové ťažkosti konzultuj s odborníkom.'
        ],
        relationships: [
          'Vyber jednu oblasť, v ktorej potrebuješ najviac podpory, a formuluj konkrétnu prosbu namiesto všeobecného „nie je mi dobre“.',
          'Dopredu si dohodni, ktoré povinnosti sa dajú počas náročnejších dní presunúť alebo rozdeliť.',
          'Ak symptómy pravidelne narúšajú prácu, vzťahy alebo bežné fungovanie, zapisuj ich aspoň dva cykly a preber záznam s gynekológom alebo všeobecným lekárom.'
        ]
      }
    }
  };

  const PROFILE_ORDER = ['sensitive', 'tired', 'body', 'cravings', 'overload'];

  class SalabomQuiz extends HTMLElement {
    constructor() {
      super();
      this.state = {
        screen: 'intro',
        questionIndex: 0,
        answers: new Array(QUESTIONS.length).fill(null),
        profile: null,
        leadTracked: false,
        submitting: false
      };
      this.config = {};
      this.abortController = null;
    }

    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.abortController = new AbortController();
      this.cacheElements();

      try {
        const configNode = this.querySelector('[data-quiz-config]');
        this.config = configNode ? JSON.parse(configNode.textContent) : {};
      } catch (error) {
        console.error('Salabom quiz: konfiguráciu sa nepodarilo načítať.', error);
        this.config = { sectionId: this.dataset.sectionId || this.id };
      }

      const restoredAfterSignup = this.restoreResultFromUrl();
      this.bindEvents();
      this.enableForm();
      this.render();
      if (restoredAfterSignup) {
        this.track('quiz_completed', {
          quiz_profile: this.state.profile,
          marketing_consent: true,
          stored_in_shopify: true
        });
        this.focusHeading();
      }
    }

    disconnectedCallback() {
      if (this.abortController) this.abortController.abort();
      this.dataset.initialized = 'false';
    }

    cacheElements() {
      this.elements = {
        intro: this.querySelector('[data-screen="intro"]'),
        question: this.querySelector('[data-screen="question"]'),
        email: this.querySelector('[data-screen="email"]'),
        result: this.querySelector('[data-screen="result"]'),
        fatal: this.querySelector('[data-screen="fatal"]'),
        questionCount: this.querySelector('[data-question-count]'),
        progressWrap: this.querySelector('[data-progress-wrap]'),
        progress: this.querySelector('[data-progress]'),
        progressText: this.querySelector('[data-progress-text]'),
        questionTitle: this.querySelector('[data-question-title]'),
        selectionInstruction: this.querySelector('[data-selection-instruction]'),
        questionHint: this.querySelector('[data-question-hint]'),
        answers: this.querySelector('[data-answers]'),
        back: this.querySelector('[data-back]'),
        next: this.querySelector('[data-next]'),
        form: this.querySelector('.salabom-quiz__email-form'),
        emailInput: this.querySelector('[data-email-input]'),
        consent: this.querySelector('[data-marketing-consent]'),
        tags: this.querySelector('[data-customer-tags]'),
        formStatus: this.querySelector('[data-form-status]'),
        previewProfileName: this.querySelector('[data-preview-profile-name]'),
        profileName: this.querySelector('[data-profile-name]'),
        profileSummary: this.querySelector('[data-profile-summary]'),
        tips: this.querySelector('[data-profile-tips]'),
        product: this.querySelector('[data-product]'),
        productImage: this.querySelector('[data-product-image]'),
        productPlaceholder: this.querySelector('[data-product-placeholder]'),
        productName: this.querySelector('[data-product-name]'),
        productPrice: this.querySelector('[data-product-price]'),
        productLink: this.querySelector('[data-product-link]'),
        addToCart: this.querySelector('[data-add-to-cart]'),
        resultLive: this.querySelector('[data-result-live]')
      };
    }

    bindEvents() {
      const signal = this.abortController.signal;
      this.querySelector('[data-start]')?.addEventListener('click', () => this.start(), { signal });
      this.elements.back?.addEventListener('click', () => this.goBack(), { signal });
      this.elements.next?.addEventListener('click', () => this.goNext(), { signal });
      this.elements.answers?.addEventListener('change', (event) => this.selectAnswer(event), { signal });
      this.elements.consent?.addEventListener('change', () => {
        this.setFormStatus('', false);
        this.updateSubmitAvailability();
      }, { signal });
      this.elements.form?.addEventListener('submit', (event) => this.handleEmailSubmit(event), { signal, capture: true });
      this.elements.productLink?.addEventListener('click', () => this.trackProductClick(), { signal });
      this.elements.addToCart?.addEventListener('click', () => this.addToCart(), { signal });
      this.querySelector('[data-restart]')?.addEventListener('click', () => this.restart(), { signal });
    }

    enableForm() {
      if (this.elements.questionCount) this.elements.questionCount.textContent = String(QUESTIONS.length);
      if (this.elements.emailInput) this.elements.emailInput.disabled = false;
      this.updateSubmitAvailability();
    }

    updateSubmitAvailability() {
      const submit = this.elements.form?.querySelector('[type="submit"]');
      if (submit) submit.disabled = this.state.submitting || !this.elements.consent?.checked;
    }

    start() {
      this.state.screen = 'question';
      this.track('quiz_started');
      this.render();
      this.focusHeading();
    }

    selectAnswer(event) {
      const input = event.target.closest('input[data-answer-index]');
      if (!input) return;
      const answerIndex = Number(input.dataset.answerIndex);
      if (!Number.isInteger(answerIndex)) return;
      const question = QUESTIONS[this.state.questionIndex];

      if (question.multiple) {
        const noneIndex = question.answers.findIndex((answer) => Object.keys(answer.scores).length === 0);
        let selected = Array.isArray(this.state.answers[this.state.questionIndex])
          ? [...this.state.answers[this.state.questionIndex]]
          : [];

        if (input.checked) {
          selected = answerIndex === noneIndex
            ? [answerIndex]
            : [...selected.filter((index) => index !== noneIndex), answerIndex];
        } else {
          selected = selected.filter((index) => index !== answerIndex);
        }
        this.state.answers[this.state.questionIndex] = [...new Set(selected)].sort((a, b) => a - b);
      } else {
        this.state.answers[this.state.questionIndex] = answerIndex;
      }

      this.elements.next.disabled = !this.hasAnswer(this.state.answers[this.state.questionIndex]);
      this.updateSelectedCards();
    }

    goNext() {
      const selection = this.state.answers[this.state.questionIndex];
      if (!this.hasAnswer(selection)) return;
      const question = QUESTIONS[this.state.questionIndex];
      const answerIndexes = Array.isArray(selection) ? selection : [selection];
      this.track('quiz_question_answered', {
        question_number: this.state.questionIndex + 1,
        question_id: question.id,
        answer: answerIndexes.map((index) => question.answers[index]?.label).filter(Boolean).join(' | '),
        multiple_choice: Boolean(question.multiple)
      });

      if (this.state.questionIndex < QUESTIONS.length - 1) {
        this.state.questionIndex += 1;
        this.renderQuestion();
        this.focusHeading();
      } else {
        this.state.profile = this.calculateProfile();
        this.state.screen = 'email';
        this.render();
        this.focusHeading();
      }
    }

    goBack() {
      if (this.state.questionIndex === 0) {
        this.state.screen = 'intro';
        this.render();
        this.focusHeading();
        return;
      }
      this.state.questionIndex -= 1;
      this.renderQuestion();
      this.focusHeading();
    }

    calculateProfile() {
      const totals = { sensitive: 0, tired: 0, body: 0, cravings: 0, overload: 0 };
      QUESTIONS.forEach((question, index) => {
        const selection = this.state.answers[index];
        const answerIndexes = Array.isArray(selection) ? selection : [selection];
        answerIndexes.forEach((answerIndex) => {
          const answer = question.answers[answerIndex];
          if (!answer) return;
          Object.entries(answer.scores).forEach(([key, value]) => {
            if (Object.prototype.hasOwnProperty.call(totals, key)) totals[key] += value;
          });
        });
      });

      const ranked = PROFILE_ORDER
        .map((key) => ({ key, score: totals[key] }))
        .sort((a, b) => b.score - a.score || PROFILE_ORDER.indexOf(a.key) - PROFILE_ORDER.indexOf(b.key));

      const topScore = ranked[0].score;
      const tied = ranked.filter((item) => item.score === topScore);

      if (topScore <= 1) return 'combined';
      if (tied.length === 1) return ranked[0].key;
      return 'combined';
    }

    handleEmailSubmit(event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      if (this.state.submitting) return;

      if (!this.elements.emailInput?.checkValidity()) {
        this.elements.emailInput?.reportValidity();
        return;
      }

      if (!this.elements.consent?.checked) {
        this.setFormStatus('Pre zobrazenie odporúčaní je potrebné zaškrtnúť marketingový súhlas.', true);
        this.updateSubmitAvailability();
        return;
      }

      this.track('quiz_email_submitted', {
        quiz_profile: this.state.profile,
        marketing_consent: true
      });
      this.trackLead();

      const result = RESULTS[this.state.profile] || RESULTS.combined;
      if (this.elements.tags) {
        this.elements.tags.value = ['newsletter', 'quiz-pms', result.tag, ...this.getAnswerTags()].join(',');
      }
      const returnTo = this.elements.form?.elements?.return_to;
      if (returnTo) {
        const returnUrl = new URL(returnTo.value, window.location.origin);
        returnUrl.searchParams.set('quiz_result', this.state.profile || 'combined');
        returnTo.value = `${returnUrl.pathname}${returnUrl.search}${returnUrl.hash}`;
      }
      const submitButton = this.elements.form?.querySelector('[type="submit"]');
      const originalButtonText = submitButton?.innerHTML || '';
      this.state.submitting = true;
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'Načítavam odporúčania...';
      }
      this.setFormStatus('', false);

      try {
        this.submitMarketingForm();
      } catch (error) {
        console.error('Salabom quiz: e-mail sa nepodarilo uložiť do Shopify.', error);
        this.setFormStatus('E-mail sa nepodarilo uložiť. Skús to, prosím, ešte raz.', true);
        this.state.submitting = false;
        if (submitButton) {
          submitButton.innerHTML = originalButtonText;
        }
        this.updateSubmitAvailability();
      }
    }

    submitMarketingForm() {
      const form = this.elements.form;
      if (!form?.action) throw new Error('Customer form nemá cieľovú URL.');

      const captcha = window.Shopify?.captcha;
      if (typeof captcha?.protect !== 'function') throw new Error('Shopify CAPTCHA nie je dostupná.');
      captcha.protect(form, () => form.submit());
    }

    getAnswerTags() {
      return QUESTIONS.flatMap((question, index) => {
        const selection = this.state.answers[index];
        const answerIndexes = Array.isArray(selection) ? selection : [selection];
        return answerIndexes.map((answerIndex) => {
          const answer = question.answers[answerIndex];
          if (!answer) return null;
          const answerCode = answer.tag || Object.keys(answer.scores)[0] || 'none';
          return `quiz-pms-answer-${question.id}-${answerCode}`;
        });
      }).filter(Boolean);
    }

    restoreResultFromUrl() {
      const url = new URL(window.location.href);
      const profile = url.searchParams.get('quiz_result');
      const wasSaved = url.searchParams.get('quiz_email_saved') === '1';
      if (!wasSaved || !RESULTS[profile]) return false;

      this.state.profile = profile;
      this.state.screen = 'result';
      this.state.leadTracked = true;
      url.searchParams.delete('quiz_email_saved');
      url.searchParams.delete('quiz_result');
      window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
      return true;
    }

    restart() {
      this.state = {
        screen: 'intro',
        questionIndex: 0,
        answers: new Array(QUESTIONS.length).fill(null),
        profile: null,
        leadTracked: false,
        submitting: false
      };
      if (this.elements.form) this.elements.form.reset();
      this.updateSubmitAvailability();
      this.setFormStatus('', false);
      this.render();
      this.focusHeading();
    }

    render() {
      ['intro', 'question', 'email', 'result', 'fatal'].forEach((name) => {
        const element = this.elements?.[name];
        if (element) element.hidden = name !== this.state.screen;
      });
      if (this.state.screen === 'question') this.renderQuestion();
      if (this.state.screen === 'email') this.renderEmail();
      if (this.state.screen === 'result') this.renderResult();
    }

    renderEmail() {
      const profileKey = RESULTS[this.state.profile] ? this.state.profile : 'combined';
      if (this.elements.previewProfileName) {
        this.elements.previewProfileName.textContent = RESULTS[profileKey].title;
      }
    }

    renderQuestion() {
      const question = QUESTIONS[this.state.questionIndex];
      if (!question || !this.elements.answers) return;

      this.elements.questionTitle.textContent = question.text;
      this.elements.selectionInstruction.textContent = question.multiple
        ? 'Viac možností · vyber všetky, ktoré platia'
        : question.id === 'age-range'
          ? 'Jedna možnosť · vyber svoju vekovú skupinu'
          : 'Jedna možnosť · označ mieru súhlasu';
      this.elements.selectionInstruction.classList.toggle('is-multiple', Boolean(question.multiple));
      this.elements.questionHint.textContent = question.hint || '';
      this.elements.questionHint.hidden = !question.hint;
      const progressStep = this.state.questionIndex + 1;
      this.elements.progressText.textContent = `Otázka ${progressStep} zo ${QUESTIONS.length}`;
      this.elements.progress.value = progressStep;
      this.elements.progress.max = QUESTIONS.length;
      this.elements.progress.setAttribute('value', String(progressStep));
      this.elements.progress.setAttribute('max', String(QUESTIONS.length));
      this.elements.progress.textContent = `${progressStep} zo ${QUESTIONS.length}`;
      this.elements.progress.setAttribute('aria-valuenow', String(progressStep));
      this.elements.progress.setAttribute('aria-valuemax', String(QUESTIONS.length));
      this.elements.answers.replaceChildren();

      const selection = this.state.answers[this.state.questionIndex];
      const selectedIndexes = Array.isArray(selection) ? selection : [selection];
      question.answers.forEach((answer, answerIndex) => {
        const label = document.createElement('label');
        label.className = 'salabom-quiz__answer';
        if (selectedIndexes.includes(answerIndex)) label.classList.add('is-selected');

        const input = document.createElement('input');
        input.type = question.multiple ? 'checkbox' : 'radio';
        input.name = `salabom-answer-${this.config.sectionId}-${this.state.questionIndex}`;
        input.value = String(answerIndex);
        input.dataset.answerIndex = String(answerIndex);
        input.checked = selectedIndexes.includes(answerIndex);

        const marker = document.createElement('span');
        marker.className = 'salabom-quiz__answer-marker';
        marker.setAttribute('aria-hidden', 'true');

        const text = document.createElement('span');
        text.className = 'salabom-quiz__answer-text';
        text.textContent = answer.label;

        label.append(input, marker, text);
        this.elements.answers.append(label);
      });

      this.elements.answers.setAttribute('role', question.multiple ? 'group' : 'radiogroup');
      this.elements.next.disabled = !this.hasAnswer(selection);
    }

    hasAnswer(selection) {
      return Array.isArray(selection) ? selection.length > 0 : Number.isInteger(selection);
    }

    updateSelectedCards() {
      const selection = this.state.answers[this.state.questionIndex];
      const selectedIndexes = Array.isArray(selection) ? selection : [selection];
      this.elements.answers?.querySelectorAll('.salabom-quiz__answer').forEach((card) => {
        const input = card.querySelector('input');
        const answerIndex = Number(input?.dataset.answerIndex);
        const isSelected = selectedIndexes.includes(answerIndex);
        if (input) input.checked = isSelected;
        card.classList.toggle('is-selected', isSelected);
      });
    }

    renderResult() {
      const profileKey = RESULTS[this.state.profile] ? this.state.profile : 'combined';
      const result = RESULTS[profileKey];
      const product = this.config.recommendedProduct || null;

      this.elements.profileName.textContent = result.title;
      this.elements.profileSummary.textContent = result.summary;
      this.elements.tips.replaceChildren();
      [
        { key: 'food', title: 'Strava' },
        { key: 'movement', title: 'Pohyb' },
        { key: 'relationships', title: 'Vzťahy a komunikácia' }
      ].forEach((category) => {
        const section = document.createElement('section');
        section.className = `salabom-quiz__advice-card salabom-quiz__advice-card--${category.key}`;

        const heading = document.createElement('h4');
        heading.className = 'salabom-quiz__advice-heading';
        heading.textContent = category.title;

        const list = document.createElement('ul');
        list.className = 'salabom-quiz__tips';
        (result.advice?.[category.key] || []).forEach((tip) => {
          const item = document.createElement('li');
          item.textContent = tip;
          list.append(item);
        });

        section.append(heading, list);
        this.elements.tips.append(section);
      });
      this.elements.resultLive.textContent = `Tvoj výsledok: ${result.title}`;
      this.renderProduct(product, profileKey);
    }

    renderProduct(product, profileKey) {
      const hasProduct = product && product.title && product.url;
      if (!this.elements.product) return;
      this.elements.product.hidden = !hasProduct;
      if (!hasProduct) return;

      this.elements.productName.textContent = product.title;
      this.elements.productPrice.textContent = product.price || '';
      this.elements.productLink.href = product.url;
      this.elements.productLink.dataset.productHandle = product.handle || '';

      if (product.image) {
        this.elements.productImage.src = product.image;
        this.elements.productImage.alt = product.imageAlt || product.title;
        this.elements.productImage.hidden = false;
        this.elements.productPlaceholder.hidden = true;
      } else {
        this.elements.productImage.hidden = true;
        this.elements.productPlaceholder.hidden = false;
      }

      const canAdd = Boolean(this.config.showAddToCart && product.variantId && product.available);
      this.elements.addToCart.hidden = !canAdd;
      this.elements.addToCart.dataset.variantId = canAdd ? String(product.variantId) : '';
      this.elements.addToCart.dataset.productHandle = product.handle || '';
      this.elements.addToCart.dataset.profile = profileKey;
    }

    async addToCart() {
      const button = this.elements.addToCart;
      const variantId = Number(button?.dataset.variantId);
      if (!button || !variantId || !this.config.cartAddUrl) return;

      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = this.config.addingToCartText || 'Pridávam…';

      try {
        const response = await fetch(this.config.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
        if (!response.ok) throw new Error(`Cart API: ${response.status}`);
        button.textContent = this.config.addedToCartText || 'Pridané do košíka ✓';
        this.track('quiz_add_to_cart', {
          quiz_profile: this.state.profile,
          product_handle: button.dataset.productHandle || ''
        });
        document.dispatchEvent(new CustomEvent('salabom:cart-updated', { bubbles: true }));
      } catch (error) {
        button.textContent = this.config.cartErrorText || 'Nepodarilo sa pridať';
        console.error('Salabom quiz: produkt sa nepodarilo pridať do košíka.', error);
      } finally {
        window.setTimeout(() => {
          button.disabled = false;
          button.textContent = originalText;
        }, 2500);
      }
    }

    trackProductClick() {
      this.track('quiz_product_clicked', {
        quiz_profile: this.state.profile,
        product_handle: this.elements.productLink?.dataset.productHandle || ''
      });
    }

    track(eventName, details = {}) {
      const payload = {
        event: eventName,
        quiz_name: this.config.quizName || 'PMS: ktorý typ máš ty? - Test',
        ...details
      };
      if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
      if (typeof window.fbq === 'function') {
        window.fbq('trackCustom', eventName, { content_name: 'quiz' });
      }
    }

    trackLead() {
      if (this.state.leadTracked || typeof window.fbq !== 'function') return;
      window.fbq('track', 'Lead', {
        content_name: 'quiz',
        lead_type: 'email_submitted'
      });
      this.state.leadTracked = true;
    }

    setFormStatus(message, isError) {
      if (!this.elements.formStatus) return;
      this.elements.formStatus.textContent = message;
      this.elements.formStatus.hidden = !message;
      this.elements.formStatus.classList.toggle('is-error', Boolean(isError));
    }

    focusHeading() {
      const active = this.querySelector('[data-screen]:not([hidden]) [data-screen-heading]');
      active?.focus({ preventScroll: false });
    }

    showFatalError() {
      this.querySelectorAll('[data-screen]').forEach((screen) => { screen.hidden = true; });
      const fatal = this.querySelector('[data-screen="fatal"]');
      if (fatal) fatal.hidden = false;
    }
  }

  customElements.define('salabom-quiz', SalabomQuiz);

  // Theme Editor normally triggers connectedCallback when it replaces section DOM.
  // This explicit hook also covers integrations that dispatch shopify:section:load
  // after moving an existing node without reconnecting it.
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target;
    const quizzes = root?.matches?.('salabom-quiz')
      ? [root]
      : (root?.querySelectorAll?.('salabom-quiz') || []);
    quizzes.forEach((quiz) => {
      if (quiz.dataset.initialized !== 'true') quiz.connectedCallback();
    });
  });
})();
